import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles((theme) => ({
    filterHeader: {
        marginTop: 50,
        marginBottom: 20
    },
    centeredRow: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'stretch',
        alignItems: 'center',
        minWidth: 150
    },
    menuItemHeader: {
        backgroundColor: theme.palette.background.paper,
        color: theme.palette.common.white,
        borderColor: theme.palette.secondary.main,
        border: "solid 1px",
        borderRadius: 5
    },
    row: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'start',
        justifyContent: "space-between",
        flexWrap: "wrap",
        width: "100%"
    },
    iconDescriptionColumn: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        fontWeight: "bold"
    },
    chart: {
        paddingTop: 20
    },
    icon: {
        height: 40,
        width: 40,
        color: theme.palette.primary.main
    },
    contentColumn: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: "space-evenly",
        flexWrap: "wrap",
        width: "70%"
    },
    dropdownLabel: {
        backgroundColor: theme.palette.background.default
    },
    filterColumn: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'start',
        justifyContent: "space-evenly",
        flexWrap: "wrap",
        width: "30%"
    },
    toggleButton: {
        width: "50%",
        marginBottom: 5
    },
    formControlDate: {
        minWidth: 300,
        margin: theme.spacing(1)
    },
    formControl: {
        width: "100%",
        margin: theme.spacing(1),
        paddingRight: 70
    },
    formControlChart: {
        minWidth: 200,
        margin: theme.spacing(1)
    },
    sourceList: {
        minWidth: 350,
        minHeight: "100vh",
        padding: 20,
        margin: 30,
        border: "solid 1px",
        backgroundImage: "linear-gradient(315deg, #cfd9df 0%, #e2ebf0 74%)"
    },
    destinationList: {
        minWidth: 350,
        minHeight: "100vh",
        padding: 20,
        margin: 30,
        border: "dashed 2px",
        backgroundImage: "linear-gradient(315deg, #f5f7fa 0%, #c3cfe2 74%)"
    },
    disciplineContainer: {
        minWidth: 400,
        margin: theme.spacing(1),
    },
    dialogTitleGreen: {
        color: theme.palette.success.main,
        fontWeight: "bold"
    },
    dialogTitleRed: {
        color: theme.palette.error.main,
        fontWeight: "bold"
    }
}));

export {useStyles};